import React, { cloneElement, Children, useRef, useEffect } from 'react';
import { getAllParams } from '../service/utils';
import useAccessibilityEscapeKey from '../hooks/useAccessibilityEscapeKey';
import PropTypes from 'prop-types';
import FocusTrap from 'focus-trap-react';

const AccessibilityIframePopup = ({ close, children, role, ...params }) => {
    const popupRef = useRef(null);
    const lastFocusedElementRef = useRef(null);

    const setLastFocusedElement = () => {
        lastFocusedElementRef.current = document.activeElement;
    };

    const restoreFocus = () => {
        if (lastFocusedElementRef.current) {
            lastFocusedElementRef.current.focus();
        }
    };

    useAccessibilityEscapeKey(() => {
        close();
        restoreFocus();
    });

    useEffect(() => {
        setLastFocusedElement();
        return () => {
            restoreFocus();
        };
    }, []);

    const child = Children.only(children);

    return (
        <FocusTrap>
            {cloneElement(child, {
                role: role || 'dialog',
                ref: popupRef,
                'aria-modal': 'true',
                'aria-labelledby': params['aria-labelledby'] || 'dialog-title',
                'aria-describedby': params['aria-describedby'] || 'dialog-description',
                tabIndex: '-1',
                ...getAllParams(params),
            })}
        </FocusTrap>
    );
};

AccessibilityIframePopup.propTypes = {
    children: PropTypes.element.isRequired,
    close: PropTypes.func.isRequired,
};

export default AccessibilityIframePopup;
